export enum AllocationViewEndpoint {
  Action = '/action',
  Allocate = '/allocate',
  AllocationDrop = '/allocation-drop',
  Attachments = '/attachments',
  Auto = '/auto',
  Manual = '/manual',
  Base = '/allocation',
  ByRule = '/by-rule',
  Brief = '/brief',
  Calendar = '/calendar',
  Carriers = '/carriers',
  Clear = '/clear',
  Compartments = '/compartments',
  Filter = '/filter',
  Available = '/available',
  Uli = '/uli',
  Ulis = '/ulis',
  Docks = '/docks',
  Dock = '/dock',
  Details = '/details',
  Prepare = '/prepare',
  Slot = '/slot',
  Slots = '/slots',
  Truck = '/truck',
  NextActions = '/next-actions',
  Languages = '/languages',
  Left = '/left',
  Restore = '/restore',
  Register = '/register',
  Release = '/release',
  Rules = '/rules',
  Update = '/update',
  Delete = '/delete',
  WebUli = '/web-uli',
  Preview = '/preview',
  History = '/history',
  Hubs = '/hubs',
  LoanerPhones = '/loaner-phones',
  ArrivalSecurityFinished = '/arrival-security-finish',
  ArrivalConfirmation = '/arrival-confirmation',
  Departure = '/departure',
  CallToArrivalSecurity = '/call-to-arrival-security',
  CallToDock = '/call-to-dock',
  Confirmation = '/confirmation',
  DepartureSecurityFinish = '/departure-security-finish',
  SealCheck = '/sealcheck',
  Sms = '/sms',
  CallToWaitingArea = '/call-to-waiting-area',
  Public = '/public',
  DriverView = '/driver-view',
  SwapBody = '/swap-body',
  Couple = '/couple',
  Decouple = '/decouple',
  RegisterNewTruck = '/register-st',
  CouplingPlan = '/coupling-plan',
}
